import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FilterListPipe } from './filter-list.pipe';
import { TranslationPipe } from './translation.pipe';
import {ExtendDatePipe} from "./extend-date.pipe";
import { FilterListByArrayPipe } from './filter-list-by-array.pipe';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    FilterListPipe,
    TranslationPipe,
    ExtendDatePipe,
    FilterListByArrayPipe
  ],
  exports: [
    FilterListPipe,
    TranslationPipe,
    ExtendDatePipe,
    FilterListByArrayPipe
  ]
})
export class PipesModule {}
